// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2rAUE","inner":"Footer_inner__1AGZU"};